<template>
  <div id="vedioWorkDetail">
    <div class="imageWorkDetail-container" v-if="data.workInfo != null">
      <div class="search-box">
        <div class="icon-box">
          <i class="el-icon-search"></i>
        </div>
        <div class="input-box">
          <input />
        </div>
      </div>
      <div class="bread-title">
        <div class="list-name">
          <span class="typename" @click="goBack"
            >{{ route.query.type == 2 ? "自由主题作品" : "主题作品" }} ></span
          >
          <span style="margin-right: 10px">{{ data.workInfo.authorName }} </span
          ><span>{{ data.workInfo.name }}</span>
        </div>
      </div>
      <div class="title">
        <span>{{ data.workInfo.authorName }}</span
        ><span>{{ data.workInfo.name }}</span>
      </div>
      <div class="work-desc">
        <p>
          {{ data.workInfo.description }}
        </p>
      </div>
      <div class="Image-box">
        <div class="videoBox">
          <video
            :src="data.workInfo.contents[0]"
            style="height: 100%; width: 100%"
            controls="controls"
            controlsList="nodownload"
            @contextmenu.prevent.stop="rightClick($event)"
          ></video>
        </div>
      </div>
      <div class="share-wrap">
        <div class="share-text">点击分享:</div>
        <el-popover
          placement="top"
          :width="100"
          trigger="click"
          @show="showCode"
          style="min-width: auto"
        >
          <template #reference>
            <div
              class="share-icon"
              @click="shareEvent('wechat')"
              :style="{
                backgroundImage: `url(${require(`../assets/img/share/wechat.png`)})`,
              }"
            ></div>
          </template>
          <div id="qrcode" ref="qrcode" style="width: 100px"></div>
        </el-popover>
        <template v-for="(item, index) in shareIcon">
          <div
            v-if="item !== 'wechat'"
            :key="index"
            class="share-icon"
            :class="{ 'copy-url': item === 'url' }"
            @click="shareEvent(item)"
            :style="{
              backgroundImage: `url(${require(`../assets/img/share/${item}.png`)})`,
            }"
          ></div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, reactive, nextTick } from "vue";
import QRCode from "qrcodejs2";

import { microBlog, qqSpace, QQ } from "../utils/share";
import { useRoute, useRouter } from "vue-router";
import { getById, markView, increaseView } from "../utils/apis/worksApi.js";
import baseInfo from "../utils/config";
export default {
  name: "vedioWorkDetail",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const shareIcon = reactive(["wechat", "QQ", "weibo", "qqSpace"]);
    const currentUrl = ref(window.location.href);
    const markRes = ref("");
    const qrcodes = ref(null);
    const data = reactive({
      workInfo: null,
    });
    getDetail();
    mark();

    function rightClick(event) {
      console.log(event);
    }
    function qrcode() {
      console.log(baseInfo);
      if (qrcodes.value) {
        qrcodes.value.clear();
        qrcode();
      } else {
        let url =
          route.query.type === 1
            ? `
        ${baseInfo.MOBILE_URL}themeWorksVideoWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`
            : `${baseInfo.MOBILE_URL}freeThemeWorksVideoWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`;
        qrcodes.value = new QRCode("qrcode", {
          width: 100,
          height: 100, // 高度
          text: url, // 二维码内容
          // render: 'canvas' // 设置渲染方式（有两种方式 table和canvas，默认是canvas）
          // background: '#f0f'
          // foreground: '#ff0'
        });
      }
    }
    async function showCode() {
      await nextTick();
      qrcode();
    }
    /**
     * 分享
     */
    function shareEvent(type) {
      console.log(type);
      if (type === "QQ") {
        let mobileurl =
          route.query.type === 1
            ? `
        ${baseInfo.MOBILE_URL}themeWorksVideoWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`
            : `${baseInfo.MOBILE_URL}freeThemeWorksVideoWorkDetail?id=${route.query.id}&type=${route.query.type}&cate=${route.query.type}&views=${route.query.views}`;
        let url = QQ({
          author: data.workInfo.authorName,
          worksname: data.workInfo.name,
          description: data.workInfo.description,
          url: mobileurl,
          pic: data.workInfo.contents[0],
        });

        console.log(url);
        window.open(encodeURI(url));
      }
      if (type === "qqSpace") {
        let url = qqSpace({
          author: data.workInfo.authorName,
          worksname: data.workInfo.name,
          description: data.workInfo.description,
          url: location.href,
          pic: data.workInfo.contents[0],
        });

        console.log(url);
        window.open(encodeURI(url));
      }
      if (type === "weibo") {
        // console.log
        let url = microBlog({
          author: data.workInfo.authorName,
          worksname: data.workInfo.name,
          url: location.href,
          pic: data.workInfo.contents[0],
        });
        window.open(encodeURI(url));
      }
    }
    function getDetail() {
      getById({ id: route.query.id }).then((res) => {
        console.log(res);
        if (res.data.code === 200) {
          data.workInfo = res.data.data;
        }
      });
    }
    function goBack() {
      if (route.query.type == 2) {
        router.push({ path: "/freeThemeWorks" });
      } else {
        router.push({ path: "/ThemeWorks" });
      }
    }

    function mark() {
      markView({ id: route.query.id }).then((res) => {
        console.log(res);
        if (res.data.code == 200) {
          markRes.value = res.data.data;
          setTimeout(() => {
            saveView();
          }, 6000);
        }
      });
    }

    function saveView() {
      increaseView({ id: route.query.id, code: markRes.value }).then((res) => {
        console.log(res);
      });
    }

    return {
      shareIcon,
      shareEvent,
      rightClick,
      currentUrl,
      route,
      goBack,
      data,
      qrcode,
      showCode,
    };
  },
};
</script>

<style lang="less" scoped>
#vedioWorkDetail {
  .imageWorkDetail-container {
    max-width: 1600px;
    min-width: 1200px;
    margin: 0 auto;
    padding-top: 30px;
    overflow: hidden;
  }
  .search-box {
    margin: 0 0 25px 0;
    height: 30px;
    display: flex;
    line-height: 30px;
    border-radius: 15px;
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
    width: 240px;
    padding-left: 15px;
    .icon-box {
      font-size: 22px;
      color: #dcdfe6;
    }
    .input-box {
      font-size: 0px;
      height: 28px;
      padding-left: 10px;
    }
    .input-box input {
      border: none;
      box-sizing: border-box;
      height: 100%;
      outline: none;
      color: #909399;
      width: 170px;
      background-color: #ffff;
    }
  }
  .bread-title {
    height: 30px;
    line-height: 30px;
    overflow: hidden;
  }
  .list-name {
    float: left;
    margin-right: 25px;
    span:first-child {
      margin-right: 8px;
      margin-left: 5px;
    }
    span {
      font-weight: bold;
      color: #000;
    }
  }
  .title {
    color: #303133;
    font-weight: bold;
    font-size: 18px;
    margin-top: 45px;
    height: 20px;
    line-height: 20px;
    margin-bottom: 20px;
    span:first-child {
      margin-right: 8px;
    }
  }
  .work-desc {
    line-height: 30px;
    color: #303133;
    margin-bottom: 45px;
  }
  .Image-box {
    padding-bottom: 40px;
  }
  .videoBox {
    height: 820px;
    margin-bottom: 40px;
    background-color: #303133;
  }
  .share-wrap {
    float: right;
    display: flex;
    width: 220px;
    margin-bottom: 60px;

    justify-content: space-between;
    overflow: hidden;
    .share-text {
      font-size: 16px;
      color: #909399;
    }
    .share-icon {
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      width: 28px;
      height: 22px;
      cursor: pointer;
    }
  }
}
video::-internal-media-controls-download-button {
  display: none;
}
video::-webkit-media-controls-enclosure {
  overflow: hidden;
}
video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
</style>
<style>
.el-popover.el-popper {
  min-width: auto;
}
</style>
